import { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
};

export const Badge = (props: PropsWithChildren<Props>) => {
  const { children, className } = props;
  return (
    <div
      className={twMerge(
        "flex items-center gap-x-0.5 rounded-2xl bg-basketBallOrange p-0.5 px-1.5 text-xs text-white",
        className
      )}
    >
      {children}
    </div>
  );
};
